<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col md="6" lg="4" xl="3">
     <!--      <v-card>
            <v-row dense>
              <v-col><v-text-field label="Totale imponibile" hide-details outlined dense readonly :value="euro(totale.imponibile)"></v-text-field></v-col>
              <v-col><v-text-field label="Sconto" hide-details outlined dense readonly></v-text-field></v-col>
              <v-col><v-text-field label="Netto merce" hide-details outlined dense readonly :value="euro(totale.imponibile)"></v-text-field></v-col>
            </v-row>  
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">IVA</th>
                    <th class="text-right">IMPONIBILE</th>
                    <th class="text-right">IMPOSTA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dettaglioIva" :key="item.aliquota">
                    <td class="text-left">{{ item.aliquota + '%' }}</td>
                    <td class="text-right">{{ item.imponibile | euro }}</td>
                    <td class="text-right">{{ item.iva | euro }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-left">Totale</th>
                    <th class="text-right">{{ totale.imponibile | euro }}</th>
                    <th class="text-right">{{ totale.iva | euro }}</th>
                  </tr>
                </tfoot>                  
              </template>
            </v-simple-table>
          </v-card> -->
        </v-col>
        <v-col md="6" lg="4" xl="3">
<!--           <v-card v-if="pagamentoVisibile">
            <v-row dense>
              <v-col><v-text-field label="Modalità di pagamento" class="text-caption" hide-details outlined dense readonly :value="modalitaPagamentoDesc"></v-text-field></v-col>              
              <v-col><v-text-field label="Condizioni di pagamento" class="text-caption" hide-details outlined dense readonly :value="condizioniPagamentoDesc"></v-text-field></v-col>
            </v-row>
            <v-row dense v-if="infoBanca">
              <v-col><v-text-field label="Banca" class="text-caption" hide-details outlined dense :value="infoBanca.descrizione"></v-text-field></v-col>
              <v-col><v-text-field label="IBAN" class="text-caption" hide-details outlined dense readonly :value="infoBanca.IBAN"></v-text-field></v-col>
            </v-row>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>SCADENZE PAGAMENTI</th>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-right">DATA</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in scadenzePagamenti" :key="item.data">
                    <td class="text-left">Rata {{index + 1}}</td>
                    <td class="text-right">{{ item.data }}</td>
                    <td class="text-right">{{ item.importo | euro }}</td>
                  </tr>
                </tbody>              
              </template>
            </v-simple-table>
          </v-card> -->
        </v-col>

       <v-col md="6" lg="4" xl="3">
<!--           <v-card>
            <v-simple-table dense class="mt-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>RIEPILOGO SPESE</th>
                  <tr>
                    <th class="text-right">DESCRIZIONE</th>
                    <th class="text-right">IMPORTO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in arrSpeseFattura" :key="item.descrizione">
                    <td class="text-right">{{ item.descrizione }}</td>
                    <td class="text-right">{{ item.importo | euro }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="text-right">TOTALE</th>
                    <th class="text-right">{{ totale.spese | euro }}</th>
                  </tr>
                </tfoot>            
              </template>
            </v-simple-table>
          </v-card> -->
        </v-col>  

        <v-col>
          <v-card>
            <v-row dense>
              <v-col>
                <v-textarea label="Annotazioni" class="text-caption" hide-details outlined dense :value="note" @change="changeNote"></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-simple-table dense class="mt-0">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-right">TOTALE QUANTITA'</th>
                        <th class="text-right">TOTALE LOTTO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-right text-h5">{{ totale.quantita }}</td>
                        <td class="text-right text-h5 blue-grey lighten-4">{{ totale.acquisto | euro }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>    
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import lotti from './lotti.js'
/* import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pData from '@/views/drawer/elementi/data'
import pProdotto from '@/views/drawer/elementi/prodotto'
import pClifor from '@/views/drawer/elementi/clifor'
import pDestinazioni from '@/views/drawer/elementi/destinazioni' */

export default {
  components: {
/*     pTesto,
    pMultiselect,
    pData,
    pProdotto,
    pClifor,
    pDestinazioni */
  },
  props: {
    locLotto: Object,
    trigger: Number
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1,
    repartiFiscali: null,
    modalitaPagamento: null,
    condizioniPagamento: null,
    speseFattura: null,
    banche: null,
    modalitaSelezionata: null,
    codizioniSelezionate: null,
    bancaAppoggio: null
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    let repartiFiscali = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
    const aliquote = await configurazioni.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
    repartiFiscali = repartiFiscali.map(x => {
      const iva = aliquote.find(al => al.codice === x.codiceIva)
      if (iva) {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: 'Iva: ' + iva.descrizione,
          aliquota: iva.aliquota
        }
      } else {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: 'Iva: non definita',
          aliquota: 0
        }
      }
    })
    this.repartiFiscali = _.uniqBy(repartiFiscali, 'repartoFiscale')
    const doc_pagamenti = await configurazioni.getConfigurazione('lotti_pagamento')
    this.modalitaPagamento = doc_pagamenti.modalitaPagamento
    this.condizioniPagamento = doc_pagamenti.condizioniPagamento
    this.speseFattura = doc_pagamenti.spese
    this.banche = doc_pagamenti.banche
    await this.calcolaDatiFooter()
  },
  watch: {
    async trigger() {
      // Verificare if (!this.modalitaPagamento) return
      await this.calcolaDatiFooter()
    }
  },
  computed: {
    totale() {
      if (this.trigger && this.locLotto && this.locLotto.totali) {
        const totale = this.locLotto.totali
        return totale.generale
      } else {
        return {}
      }
    },
    dettaglioIva() {
      if (this.trigger && this.locLotto) {
        const totali = _.omit(this.locLotto.totali, 'generale')   
        const ive = Object.values(totali)
        return ive
      } else {
        return {}
      }
    },
    scadenzePagamenti() {
      if (this.trigger && this.locLotto) {
        return this.locLotto.scadenze
      } else {
        return []
      }
    },
    arrSpeseFattura() {
      if (this.trigger && this.locLotto) {
        return this.locLotto.spese
      } else {
        return []
      }
    },
    pagamento() {
     if (this.trigger && this.modalitaSelezionata) {
        return this.modalitaSelezionata
      } else {
        return {}
      }
    },
    modalitaPagamentoDesc() {
      return  _.get(this.modalitaSelezionata, 'descrizione', '')
    },
    condizioniPagamentoDesc() {
      return  _.get(this.codizioniSelezionate, 'descrizione', '')
    },
    infoBanca() {
      return  this.bancaAppoggio
    },
    pagamentoVisibile() {
      return this.trigger && _.get(this.locLotto, 'appoggio.pagamentoVisibile', false)
    },
    note() {
      if (this.locLotto) {
        return this.locLotto.note
      } else {
        return ''
      }
    }
  },
  methods: {
    async calcolaDatiFooter() {
      var totali = {}
      const clifor = this.locLotto.appoggio.clifor
      if (!clifor || this.locLotto.righe.length === 0) return

      const speseFattura = clifor.fatturazione.spese || []
      let { valori, acquisto } = lotti.calcolaValoriLotto(this.locLotto, this.repartiFiscali)
      if (valori.length === 0) return
      totali = lotti.calcolaTotaliAliquote_v2(totali, valori)
      let totaleCompleti = lotti.calcolaTotaliAliquoteSpese(totali, speseFattura/* , scontoInFattura */)

      const { spese, totaleSpese } = lotti.calcolaSpese(speseFattura, totaleCompleti.generale.imponibile, totaleCompleti.generale.imponibile)
      totaleCompleti.generale.acquisto = acquisto
      this.locLotto.totali = totaleCompleti

      this.locLotto.spese = spese
      await this.$nextTick()
      this.$emit('updateTotali')
    },
    euro(value) {
      return this.$options.filters.euro(value)
    },
    changeNote(value) {
      this.componentValueChange({ model: 'note', subModel: null, value })
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locLotto, tgt)
      await this.aggiornaCorrelati(data)
      this.$store.commit('documenti/SET_DOCUMENTO', this.locLotto) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      this.locLotto.appoggio = this.locLotto.appoggio || {}
      switch (data.model) {
         case 'tipoLotto.codice':
          this.locLotto.appoggio.tipoLotto = data.value
          this.locLotto.appoggio.clienteVisibile = data.value.visualizzaCliente
          this.locLotto.appoggio.fornitoreVisibile = data.value.visualizzaFornitore
          this.locLotto.appoggio.spedizioneVisibile = data.value.infoSpedizione
          this.locLotto.appoggio.pagamentoVisibile = data.value.infoPagamento
          this.locLotto.tipoLotto = data.value
          // this.locLotto.tipoLottoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locLotto.appoggio.clifor = clifor
           _.set(this.locLotto,'appoggio.clifor', clifor)
          _.set(this.locLotto, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
           _.set(this.locLotto, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
           const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
           _.set(this.locLotto, 'spedizione.destinazione', sede)
           _.set(this.locLotto, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
           _.set(this.locLotto, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))
           await this.$nextTick()
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locLotto, 'spedizione.destinazione', data.value)
          break;
        default:
          break
      } 
    }
  }
}

</script>
